import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { Logo } from "./Logo";
import { LegalLinks, MerchantBlock } from "./LegalLinks";
import { CardMarks } from "../payments/CardMarks";
import { isRealSocial } from "../../lib/social";

const SOCIAL = [["linkedin", Linkedin, "LinkedIn"], ["facebook", Facebook, "Facebook"], ["instagram", Instagram, "Instagram"], ["youtube", Youtube, "YouTube"]];

export default function Footer() {
  const { navigation, settings, legal } = useSite();
  const items = (navigation?.items || []).filter((i) => i.visible);
  const social = SOCIAL.filter(([k]) => isRealSocial(settings?.social?.[k]));
  return (
    <footer className="on-dark border-t-4 border-gold bg-navy text-white" data-testid="site-footer">
      <div className="container-site grid gap-10 py-12 md:grid-cols-12 md:items-center">
        <div className="md:col-span-4 md:border-r md:border-white/20 md:pr-8">
          <Logo size="lg" />
          <p className="mt-3 text-xs uppercase tracking-[0.25em] text-white/80">{settings?.tagline}</p>
        </div>
        <nav aria-label="Footer" className="md:col-span-4 md:border-r md:border-white/20 md:px-8">
          <ul className="flex flex-wrap gap-x-6 gap-y-3 text-[15px]">
            {items.map((i) => (
              <li key={i.path}><Link to={i.path} className="text-white/90 hover:text-gold" data-testid={`footer-link-${i.label.toLowerCase()}`}>{i.label}</Link></li>
            ))}
          </ul>
        </nav>
        <div className="md:col-span-4 md:pl-8">
          {social.length > 0 && (
            <ul className="mb-4 flex gap-5" aria-label="Social media">
              {social.map(([k, Ico, label]) => (
                <li key={k}><a href={settings.social[k]} target="_blank" rel="noopener noreferrer" aria-label={label}
                  className="text-white hover:text-gold" data-testid={`footer-social-${k}`}><Ico size={22} /></a></li>
              ))}
            </ul>
          )}
          <MerchantBlock m={legal?.merchant} className="text-sm text-white/85" />
          <CardMarks tone="dark" className="mt-4" testid="footer-card-marks" />
        </div>
      </div>
      <div className="border-t border-white/15">
        <div className="container-site flex flex-col gap-4 py-5 text-sm md:flex-row md:items-center md:justify-between">
          <LegalLinks pages={legal?.pages} className="flex flex-wrap gap-x-6 gap-y-2" linkClass="text-white/90 underline-offset-4 transition-colors hover:text-gold hover:underline" />
          <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
            <p className="text-white/75" data-testid="footer-copyright">{settings?.copyright}</p>
            <Link to="/admin" className="text-xs text-white/60 hover:text-white" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
